module.exports = __webpack_public_path__ + "img/04.7b1a736b.jpeg";